import { render, staticRenderFns } from "./VideoExternalPicker.vue?vue&type=template&id=ef65002e"
import script from "./VideoExternalPicker.vue?vue&type=script&lang=js"
export * from "./VideoExternalPicker.vue?vue&type=script&lang=js"
import style0 from "./VideoExternalPicker.vue?vue&type=style&index=0&id=ef65002e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports